import { render, staticRenderFns } from "./BetAlert.vue?vue&type=template&id=3acfeea0&scoped=true&"
import script from "./BetAlert.vue?vue&type=script&lang=js&"
export * from "./BetAlert.vue?vue&type=script&lang=js&"
import style0 from "./BetAlert.vue?vue&type=style&index=0&id=3acfeea0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acfeea0",
  null
  
)

component.options.__file = "BetAlert.vue"
export default component.exports